import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';
import { findDomElementFilterFn } from '../../../../findDomElement';
import { articlePageContainer, articlePostEditorial, pageContent, articlePostContainer } from "../../../../../components/Pages/ArticlePostPage/scss/ArticlePostPage.module.scss"; 
import { getHref, getId } from "../../../../../graphql/transformers/post/articleTitles";
import TableOfContent from '../../../../../components/Molecules/TableOfContent/TableOfContent';
import { classAttribute, testAttributes } from './Constants';

const filterByClassName = (className) => (element) => element?.attribs?.class?.includes(className);

const toTableOfContent = (parserData) => 
{
    const { parserOptions: { replaceFn } } = parserData;

    const Wrapper = ({ name = '', type = '', attribs = {}, children }) => 
    {   
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        if (!attribs?.class?.includes(classAttribute)) return null;

        const props = {}
        const foundTableList = findDomElementFilterFn({ 
            element: children?.filter(child => child.type === "tag")?.at(0),
            filterFn: filterByClassName('cdm-customizations-table-of-content-list') 
        })
        const foundTableContent = children?.filter(child => child.type === "tag")?.at(1);

        const headingTitle = findDomElementFilterFn({ 
            element: children?.filter(child => child.type === "tag").at(0), 
            filterFn: filterByClassName('toc-title')
        })

        const foundItemList = foundTableList?.children?.filter(child => child.type === "tag");

        if (headingTitle)
        {
            props.headline = headingTitle.children[0].data;
        }

        if (foundItemList)
        {
            props.articleTitles = foundItemList.map((item) =>
            {
                const label = item?.children?.filter(child => child.type === "tag")?.at(0)?.children?.at(0)?.data;  

                return {
                    label,
                    href: getHref(label),
                    id: getId(label),
                };
            });
        }

        return <div className={articlePageContainer}>
            <div
                className={articlePostContainer} 
            >
                <div
                    className={`${articlePostEditorial} ${pageContent}`}
                    data-testid={testAttributes.TABLE_OF_CONTENT_CONTAINER}
                >
                    <TableOfContent {...props} />
                    <article>{foundTableContent && domToReact( foundTableContent?.children, replaceFn())}</article>
                </div>
            </div>
        </div>
        
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
        children: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])),
    };

    return Wrapper;
};

export default toTableOfContent;
